import { writable } from 'svelte/store';

export const loginErrors = writable({});
